import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import AvisoLegal from "@/pages/AvisoLegal";
import Privacidad from "@/pages/Privacidad";
import Cookies from "@/pages/Cookies";
import CookieBanner from "@/components/CookieBanner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/aviso-legal" element={<AvisoLegal />} />
                    <Route path="/politica-privacidad" element={<Privacidad />} />
                    <Route path="/politica-cookies" element={<Cookies />} />
                </Routes>
                <CookieBanner />
            </BrowserRouter>
        </div>
    );
}

export default App;
